import { Box, IconButton, makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";

import { CustomButton } from "@/components/Button";
import { TextLink } from "@/components/TextLink";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  panel: {
    position: "relative",
    width: "100%",
    maxWidth: 434,
    padding: "48px 24px 32px",
    borderRadius: 16,
    backgroundColor: theme.palette.semantic["surface/card"],
    border: `1px solid ${theme.palette.semantic["border/default"]}`,
    color: theme.palette.text.primary,
    textAlign: "center",
    fontSize: 14,
    lineHeight: 1.5,
  },
  close: { position: "absolute", right: 4, top: 4, width: 44, height: 44 },
  title: { fontSize: 16, fontWeight: 700, lineHeight: 1.3, marginBottom: 8 },
  description: { fontSize: 14, lineHeight: 1.5, color: theme.palette.text.secondary },
  custom: { textAlign: "left", "& a": { color: theme.palette.primary.main } },
}));

interface NetworkErrorContentProps extends React.HTMLAttributes<HTMLDivElement> {
  closeSnackbar: Function;
  ErrorMessage?: React.FC;
}
const NotifyNetworkErrorContent = React.forwardRef<HTMLDivElement, NetworkErrorContentProps>(function NetworkErrorContent(
  { closeSnackbar, ErrorMessage, className, ...props }, ref
) {
  const classes = useStyles();
  return (
    <div {...props} ref={ref} className={`${classes.panel} ${className ?? ""}`} role="alert">
      <IconButton className={classes.close} aria-label="エラーを閉じる" onClick={() => closeSnackbar("network_error")}>
        <CloseIcon />
      </IconButton>
      {ErrorMessage ? (
        <Box className={classes.custom}>
          <ErrorMessage />
        </Box>
      ) : (
        <>
          <Typography component="h2" className={classes.title}>
            通信できませんでした
          </Typography>
          <Typography className={classes.description}>
            通信状況を確認して、
            <br />
            もう一度お試しください。
          </Typography>
          <Box mt={2}>
            <CustomButton tone="outline" buttonSize="M" fullWidth={false} onClick={() => window.location.reload()}>
              再読み込み
            </CustomButton>
          </Box>
          <Box mt={2}>
            <TextLink href="https://form.run/@propally-1619963249" underline>
              報告フォーム
            </TextLink>
          </Box>
        </>
      )}
    </div>
  );
});

export const NotifyNetworkError = (
  enqueueSnackbar: Function,
  closeSnackbar: Function,
  ErrorMessage?: React.FC
): void => {
  const panel = <NotifyNetworkErrorContent closeSnackbar={closeSnackbar} ErrorMessage={ErrorMessage} />;
  enqueueSnackbar(panel, {
    key: "network_error",
    persist: true,
    content: () => panel,
  });
};
